import styles from './RegModeOne.module.css'
import React, {useContext, useEffect, useRef, useState} from "react";
import SelectNumber, {SimCardUnitInt} from "../SelectNumber/SelectNumber";
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setBaseRegion, setOrderData, setSlider} from "../../Reducer/GlobalReducer";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import WaitLoader from "../../WaitLoader/WaitLoader";
import RuPersonalData, {PersonalDataInt} from "../PersonalData/PersonalData";
import Payment, {PaymentInt} from "../Payment/Payment";
import DeliveryItem from "../DeliveryItem/DeliveryItem";
import {SliderContext} from "../../Slider/Slider";
import {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import ClientInfoItem from "../ClientInfoItem/ClientInfoItem";
import Coupon from "../Coupon/Coupon";
import {useNavigate} from "react-router-dom";

interface RegModeOnePropsInt
{
    parentWidth?:number
}


export default function RegModeOne({parentWidth}:RegModeOnePropsInt)
{

    const navigate = useNavigate()

    const [error,setError] = useState("")

    const prefDomain = useSelector((state: ReduxStateInt) => {
        return state.prefDomain
    })

    const dispatch = useDispatch()
    const orderData = useSelector((state: ReduxStateInt) => {
        return state.orderData
    })

    const dataCardItem = useSelector((state: ReduxStateInt) => {
        return state.slider?.dataCardItem
    })

    const [selectedCtn,setSelectedCtn] = useState<SimCardUnitInt>()


    const region = useSelector((state: ReduxStateInt) => {
        return state.baseRegion
    })

    const [stage, setStage] = useState(0)


    const [showDetails, setShowDetails] = useState(true)

    useEffect(()=>{
        setStage(0)
    },[region.makeSelectRegion])

    useEffect(()=>{
        if(stage === 0)
        {
            dispatch(setOrderData({}))
        }
    },[orderData?.tarifData?.tarifId])


    useEffect(()=>{
        if(prefDomain?.skipCoupon || !dataCardItem?.useCoupon) setStage(2)
    },[prefDomain, dataCardItem])

    const stageNumberSelectResult = (sim:SimCardUnitInt | undefined)=>{
        setStage(2)
    }

    const stagePersonalDataResult = (data: PersonalDataInt | undefined)=>{

        setStage(3)
    }

    const stagePaymentResult = (data: PaymentInt) =>{
        setStage(5)
    }

    const stageCouponResult = ()=>{
        setStage(2)
    }


    const stageDeliveryResult = ()=>{
        setStage(4)
        setShowDetails(true)
    }


    const ctnData = orderData?.ctnData

    if(stage === 5) return (
        <ClientInfoItem/>
    )

    const useCoupon = !! dataCardItem?.useCoupon

    const xPrice = orderData?.tarifData?.newPrice !== undefined ? orderData?.tarifData?.newPrice : orderData?.tarifData?.price

    const actPrice = dataCardItem?.bundleOne?.actCost ? dataCardItem?.bundleOne?.actCost : 0
    return(

        <div className={[styles.orderCont, styles.orderContBorder].join(' ')} >


                {showDetails &&
                    <div className={styles.orderOneStageCont}>
                        <div className={styles.orderLine}>
                            <div >Режим :</div>
                            <span className={styles.span}>Новая сим карта</span>
                        </div>
                        <div className={styles.orderLine}>
                            <div >Оператор :</div>
                            <span className={styles.span}>{orderData?.tarifData?.operName}</span>
                        </div>
                        <div className={styles.orderLine}>
                            <div >Ваш тариф :</div>
                            <span className={styles.span}>{orderData?.tarifData?.name}</span>
                        </div>

                        <div className={styles.orderLine}>
                            <div >Регион подключения :</div>
                            <span className={styles.span}>{orderData?.regionData?.macroRegionName?.replace(/Регион :/ui,'')}</span>
                        </div>


                        {orderData?.couponId &&
                            <div className={styles.orderLine}>
                                <div >Примененный купон</div>
                                <span className={[styles.span, styles.blueColor].join(' ')}>{orderData?.couponId}</span>
                            </div>
                        }
                        <div className={styles.orderLine}>
                            <div >Стоимость подключения на тариф :</div>
                            <span className={[styles.redColor,styles.span].join(' ')}>{xPrice + " руб."}</span>
                        </div>

                        { actPrice > 0 &&
                            <div className={styles.orderWar}>
                                <div>Внимание, оператор {orderData?.tarifData?.operName?.toLowerCase()} взимает <span>единоразовую</span> плату за активацию номера в размере {actPrice + " руб."}</div>
                            </div>

                        }


                        { stage>2 &&
                            <div className={styles.orderLine}>
                                <div >Персональные данные :</div>
                                <span className={styles.span}>ОК</span>
                            </div>
                        }
                        { stage>3 &&
                            <div className={styles.orderLine}>
                                <div >Стоимость доставки :</div>
                                <span className={styles.span}>{orderData?.deliveryData?.price + " руб."}</span>
                            </div>
                        }
                        { stage>4 &&
                            <div className={styles.orderLine}>
                                <div >Платеж :</div>
                                <span className={styles.span}>{orderData?.paymentData?.amount + " руб."}</span>
                            </div>
                        }
                        { stage>4 &&
                            <div className={styles.orderLine}>
                                <div >Ваш номер заказа :</div>
                                <span className={styles.span}>{orderData?.orderId}</span>
                            </div>
                        }
                    </div>
                }




            {stage===0 &&

                <div className={styles.btnCont}>

                    <button type="button" className="btn btn-face "
                            onClick={()=>{
                                dispatch(setSlider({sliderMode:0}))
                                navigate('/')
                            }}
                    >Отменить</button>

                    <button type="button" className="btn btn-face "
                            onClick={()=>{
                                setShowDetails(false)
                                setStage(2)
                            }} // на персональные данные
                    >Продолжить</button>

                </div>

            }

            {stage === 777 &&
                <div className={styles.coupCont}>
                    <Coupon cbExecute={stageCouponResult}/>
                </div>
            }



            {stage===1 &&
                <SelectNumber cbExecute={stageNumberSelectResult}/>

            }

            {stage===2 &&
                <RuPersonalData cbExecute={stagePersonalDataResult}/>
            }


            {stage===3 &&
                <DeliveryItem cbExecute={stageDeliveryResult} contWidth={ parentWidth ? parentWidth : 0 } />
            }

            {stage===4 &&
                <Payment cbExecute={stagePaymentResult}></Payment>
            }

            {stage === -1 &&
                <div>{error}</div>
            }

        </div>

    )
}